import { Map } from 'immutable';
import moment from 'moment';
import { pathSubscription } from 'nike-re-framejs';

export const isInRange = (minutes, limit) => limit >= minutes && minutes >= 0;
export const calculateMinutes = (start, end) => moment(start).diff(end, 'minutes');

export const initNotificationBox = db => db.setIn(['tournaments', 'showPopup'], true);

export function mergeTournamentsPriority(db, ready, starting) {
    const readyTournaments = ready
        .filter(
            tournament =>
                isInRange(calculateMinutes(tournament.get('start'), moment.now()), 2880) &&
                tournament.get('status') === 'Ready'
        )
        .sortBy(tournament => calculateMinutes(moment.now(), tournament.get('start')))
        .reverse()
        .toMap();

    const startingTournaments = starting
        .filter(
            tournament =>
                calculateMinutes(tournament.get('end'), moment.now()) >= 0 && tournament.get('status') === 'Active'
        )
        .sortBy(tournament => calculateMinutes(tournament.get('end'), moment.now()))
        .reverse()
        .toMap();

    db = db.setIn(['tournaments', 'tournaments', 'byPriority'], Map());
    startingTournaments.concat(readyTournaments).forEach(tournament => {
        db = db.setIn(['tournaments', 'tournaments', 'byPriority', tournament.get('id')], tournament);
    });
    return db;
}

export const notificationPopupStatus$ = pathSubscription(['tournaments', 'showPopup']);
export const getTournamentsPriority$ = pathSubscription(['tournaments', 'tournaments', 'byPriority']);
